import MeetingRoomForm from '@/views/App/MeetingRoom/Form.vue';
import MeetingRoomList from '@/views/App/MeetingRoom/List.vue';

const routesMeetingRoom = [
    {
        path: 'meeting-room',
        name: 'meetingRoomList',
        component: MeetingRoomList
    },
    {
        path: 'form/:id?',
        name: 'meetingRoomForm',
        component: MeetingRoomForm
    }
  ];

export default routesMeetingRoom;